// extracted by mini-css-extract-plugin
export default {"tabPanel":"Tabs_tabPanel__btuiZ","tabMenu":"Tabs_tabMenu__Q7+aZ","tab":"Tabs_tab__L5pOr","tabSelected":"Tabs_tabSelected__JHM65 Tabs_tab__L5pOr","tabLabel":"Tabs_tabLabel__86g2g"};